import { computed } from 'vue'

export function useSetSelectClassStyle({ props, disabled, selected, iValueText, errorTip, changed, ToForm }) {
	const setClass = computed(() => {
		const arr = ['to-disable-target']
		if (errorTip.value) {
			arr.push('to-select-mode-line')
			arr.push('to-select-color-danger')
			arr.push('to-select-tip-show')
		} else {
			if (props.mode) {
				for (let i = 0; i < props.mode.split(' ').length; i++) {
					arr.push(`mode-${props.mode.split(' ')[i]}`)
				}
			}
			if (props.color) {
				arr.push(`color-${props.color}`)
			}
			if (props.multiple) {
				arr.push('is-multiple')
				if (selected.value.length === 0) {
					arr.push('is-placeholder')
				}
			} else {
				if (selected.value && selected.value[iValueText.value] === '') {
					arr.push('is-placeholder')
				}
			}
			if (errorTip.value) {
				//
			}
			if (props.filterable || props.remoteMethod) {
				arr.push('is-filterable')
			}
			if (disabled.value) {
				arr.push('is-disabled')
			}
			if (changed.value) {
				arr.push('is-changed')
			}
			if (props.wrap) {
				arr.push('is-wrap')
			}
			if (props.native) {
				arr.push('is-native')
			}
			if ((ToForm && ToForm.comparable) || props.comparable) {
				arr.push('to-compare')
			}
		}

		return arr
	})

	const setStyle = computed(() => {
		const obj: any = {}
		if (props.width) {
			if (!isNaN(Number(props.width))) {
				obj.width = props.width + 'em'
			} else if (props.width === 'full') {
				obj.width = '100%'
			} else {
				obj.width = props.width
			}
		}
		return obj
	})

	return {
		setClass,
		setStyle
	}
}
